import { gql } from '@apollo/client';

export const TAX_RATES_QUERY = gql`
  query taxRates($pager: PagerInputNew, $filters: TaxRateFilterInput) {
    taxRates(pager: $pager, filters: $filters) {
      total
      values {
        id
        code
        description
        percent
        category
      }
    }
  }
`;
